<template>
  <div>
    <b-container fluid id="main-container">
      <p>
      {{admin}}
      </p>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "AdminComponent",
  mounted() {
  this.$http.get(this.$hostname + '/api/create_admin_user')
    .then(response => { 
      this.admin = response.data.status
    })
    .catch(error => {
      console.error(error);
    });
  },
  data() {
    return {
      admin: 'Generating admin user',
    };
  },
  methods: {
    redirectToGUI(type, id) {
      if (type==='Other') {
        this.$router.push({
          name: 'semanticshifttable',
          params: {
            model_id: id
          }
        })
      }
      else {
        console.log('Type not implemented yet')
      }
    },
      
  }
}
</script>

<style>

</style>